/* eslint-disable no-nested-ternary */
/* eslint-disable no-unused-vars */
/**
 * © [2022] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */

import * as actiontypes from './actiontypes';
const initialState = {
  ar_smry_tbl: [],
  ar_fld: [],
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case actiontypes.AR_SUMMARY_TABLE:
      let getPgmVal = Object.keys(action.payload)[0];
      if (state.ar_smry_tbl.length != 0) {
        let main = state?.ar_smry_tbl?.forEach(function (obj) {
          delete obj[getPgmVal];
        });
      }
      return {
        ...state,
        ar_smry_tbl: [...state.ar_smry_tbl, action.payload],
      };
    case actiontypes.AR_SUMMERY_FIELD:
      let getPgmValSingle = Object.keys(action.payload)[0];
      if (state.ar_fld.length != 0) {
        let main = state?.ar_fld?.forEach(function (obj) {
          delete obj[getPgmValSingle];
        });
      }
      return {
        ...state,
        ar_fld: [...state.ar_fld, action.payload],
      };
    case actiontypes.AR_SUMMERY_MFG_FIELD_CLEAR_REDUX:
      return {};
    default:
      return state;
  }
};

export default reducer;
